import { loadTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RouterContextProvider } from "./context/RouterContext.jsx";
import {
  localStorageEventHandler,
  UserContextProvider,
} from "./context/UserContext.jsx";
import { onMessageListener } from "./firebase.js";
import { sendNotification } from "./helper/notificationHandler.js";
import "./scss/style.scss";
import { getCurrentUserId } from "./services/loginService.js";
import {
  connection,
  startConnection,
  stopConnection,
} from "./signalRService.js";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const loading = (
  <div className='pt-3 text-center'>
    <div className='sk-spinner sk-spinner-pulse'></div>
  </div>
);

loadTheme({
  defaultFontStyle: {
    fontFamily: "vazir",
  },
});

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout.jsx"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login.jsx"));

const App = () => {
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const newMessagesCount = useSelector((state) => state.newMessagesCount);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      const onReceiveMessageBadge = (message) => {
        if (!message) {
          console.error("Message is undefined or null.");
          return;
        }

        dispatch({
          type: "set",
          newMessagesCount: Number(newMessagesCount + 1),
        });

        if (`${message?.senderUserId}` !== `${getCurrentUserId()}`) {
          sendNotification(message?.senderName, message?.text);
        }
      };
      connection?.on("ReceiveMessage", onReceiveMessageBadge);

      return () => connection?.off("ReceiveMessage", onReceiveMessageBadge);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    window.dispatchEvent(localStorageEventHandler);

    onMessageListener()
      .then(() => {})
      .catch((err) => console.log("Notification listener failed: ", err));

    startConnection();
    return () => {
      stopConnection();
    };
  }, []);

  function handleWindowSizeChange() {
    dispatch({
      type: "set",
      isMobile: window?.innerWidth < 500,
    });
  }
  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <BrowserRouter>
      <RouterContextProvider>
        <UserContextProvider>
          <React.Suspense fallback={loading}>
            <Routes>
              <Route path='/login' name='Login Page' element={<Login />} />{" "}
              {isAuthenticated && (
                <Route path='*' name='Home' element={<DefaultLayout />} />
              )}
            </Routes>
          </React.Suspense>
        </UserContextProvider>
      </RouterContextProvider>
    </BrowserRouter>
  );
};

export default App;
